import { Component, inject, HostListener } from '@angular/core';
import { ASSETS } from '@app/core/constants/assets.constants';
import { APP_ROUTES } from '@app/core/constants/routes.constants';
import { RouterLink, RouterLinkActive, Router } from '@angular/router';
import { CommonModule } from '@angular/common';

interface DropdownItem {
  label: string;
  subtitle?: string;
  icon?: string;
  iconUrl?: string;
  routerLink?: string | string[];
}

interface DropdownSection {
  title: string;
  items: DropdownItem[];
  viewAllLink?: string | string[];
  viewAllLabel?: string;
}

@Component({
  selector: 'app-guest-header',
  imports: [RouterLink, RouterLinkActive, CommonModule],
  templateUrl: './guest-header.html',
  styleUrl: './guest-header.scss',
})
export class GuestHeader {
  menuOpen = false;
  ASSETS = ASSETS;
  APP_ROUTES = APP_ROUTES;
  activeDropdown: string | null = null;
  mobileMenuOpen = false;
  mobileActiveSection: string | null = null;
  mobileActiveCategory: string | null = null;

  constructor(private router: Router) {}

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    // Only close on click outside for desktop, not mobile
    if (window.innerWidth > 991) {
      if (
        !target.closest('.guest-header__dropdown-container') &&
        !target.closest('.guest-header__dropdown-trigger')
      ) {
        this.activeDropdown = null;
      }
    }
  }

  private mouseLeaveTimeout: any = null;

  onMouseEnter(menu: string) {
    // Only auto-open on hover for desktop
    if (window.innerWidth > 991) {
      // Clear any pending close timeout
      if (this.mouseLeaveTimeout) {
        clearTimeout(this.mouseLeaveTimeout);
        this.mouseLeaveTimeout = null;
      }
      this.activeDropdown = menu;
    }
  }

  onMouseLeave() {
    // Only auto-close on mouse leave for desktop
    if (window.innerWidth > 991) {
      // Delay to allow moving to dropdown
      this.mouseLeaveTimeout = setTimeout(() => {
        if (window.innerWidth > 991) {
          this.activeDropdown = null;
        }
      }, 200);
    }
  }

  onDropdownMouseEnter() {
    // Keep dropdown open when hovering over it
    if (window.innerWidth > 991) {
      if (this.mouseLeaveTimeout) {
        clearTimeout(this.mouseLeaveTimeout);
        this.mouseLeaveTimeout = null;
      }
    }
  }

  onDropdownMouseLeave() {
    // Close dropdown when mouse leaves it
    if (window.innerWidth > 991) {
      this.activeDropdown = null;
    }
  }

  toggleDropdown(menu: string, event: Event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.activeDropdown === menu) {
      this.activeDropdown = null;
    } else {
      this.activeDropdown = menu;
    }
  }

  closeDropdown() {
    this.activeDropdown = null;
  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

  signIn() {
    this.router.navigate([APP_ROUTES.AUTH.ROOT, APP_ROUTES.AUTH.SIGNIN]);
    this.closeDropdown();
  }

  signUp() {
    this.router.navigate([APP_ROUTES.AUTH.ROOT, APP_ROUTES.AUTH.SIGNUP]);
    this.closeDropdown();
  }
  closeMenu() {
    const navbar = document.getElementById('guestNavbar');
    if (navbar?.classList.contains('show')) {
      const bsCollapse = new (window as any).bootstrap.Collapse(navbar, { toggle: true });
      bsCollapse.hide();
    }
    this.mobileMenuOpen = false;
    this.mobileActiveSection = null;
    this.mobileActiveCategory = null;
  }

  toggleMobileMenu() {
    this.mobileMenuOpen = !this.mobileMenuOpen;
    if (!this.mobileMenuOpen) {
      this.mobileActiveSection = null;
      this.mobileActiveCategory = null;
    }
  }

  openMobileSection(category: string) {
    this.mobileActiveCategory = category;
    this.mobileActiveSection = null;
  }

  backToMobileMenu() {
    this.mobileActiveCategory = null;
    this.mobileActiveSection = null;
  }

  toggleMobileSubSection(section: string) {
    if (this.mobileActiveSection === section) {
      this.mobileActiveSection = null;
    } else {
      this.mobileActiveSection = section;
    }
  }
  leftMenuItems = [
    {
      label: 'Platform',
      routerLink: [
        'product',
        APP_ROUTES.GUEST.PLATFORM.ROOT,
        APP_ROUTES.GUEST.PLATFORM.PRODUCT_OVERVIEW,
      ],
      hasDropdown: true,
    },
    {
      label: 'Resources',
      routerLink: [APP_ROUTES.GUEST.SUPPORT.ROOT, APP_ROUTES.GUEST.SUPPORT.HELP_CENTER],
      hasDropdown: true,
    },
    {
      label: 'Enterprise',
      routerLink: APP_ROUTES.GUEST.ENTERPRISE,
      hasDropdown: false,
    },
    {
      label: 'Pricing',
      routerLink: APP_ROUTES.GUEST.PRICING,
      hasDropdown: false,
    },
  ];

  // dropdownAssets = {
  //   platformItemIcon: 'https://www.figma.com/api/mcp/asset/ffe7f9e4-c38c-4740-b8bb-94c845aacabc',
  //   platformArrowIcon: 'https://www.figma.com/api/mcp/asset/0aa26aeb-dd72-486d-88a1-e1a0eae65f78',
  //   platformArrowIconAlt: 'https://www.figma.com/api/mcp/asset/28099ab5-41b9-45bf-b56f-f46568294f13',
  //   resources: {
  //     documentation: 'https://www.figma.com/api/mcp/asset/7c9c26a6-6534-4912-9868-59636caecb1a',
  //     features: 'https://www.figma.com/api/mcp/asset/08ca8e0a-16ae-4f32-943a-f180ae0e661e',
  //     tutorials: 'https://www.figma.com/api/mcp/asset/e0644f04-0b23-4321-90cf-b70592e9adce',
  //     help: 'https://www.figma.com/api/mcp/asset/e7b74ce6-d106-46be-93f1-ad7500ef3c09',
  //     faq: 'https://www.figma.com/api/mcp/asset/c7177399-0e6b-4eaf-95d6-69f7d63d5f73',
  //     phone: 'https://www.figma.com/api/mcp/asset/1a47732f-6342-45d7-9c06-26236dc77f36',
  //     about: 'https://www.figma.com/api/mcp/asset/957fd1b3-d1e7-478a-a8f3-e318de9b6609',
  //     blog: 'https://www.figma.com/api/mcp/asset/6643292b-e2ef-4979-bca8-2e0bc3d78189',
  //     careers: 'https://www.figma.com/api/mcp/asset/94f1bba4-892e-4059-9589-437fd5c13e13',
  //     partners: 'https://www.figma.com/api/mcp/asset/0bcfc00b-9751-4f43-aa8a-f2a03b0f1b6c',
  //   },
  // };

  // mobileMenuAssets = {
  //   arrowRight: 'https://www.figma.com/api/mcp/asset/146bfe3d-4c02-4410-85d4-6eec705fc006',
  //   arrowRightAlt: 'https://www.figma.com/api/mcp/asset/ac81c121-55e0-423a-a676-bfcb6aa4955c',
  //   arrowBack: 'https://www.figma.com/api/mcp/asset/be60cf68-6888-4b85-bcc1-74c795219397',
  //   arrowDown: 'https://www.figma.com/api/mcp/asset/e7244b6d-f9a7-43f0-88c4-9ec6d9aafad0',
  //   viewAllArrow: 'https://www.figma.com/api/mcp/asset/dbfc15bc-e2d4-471a-ab8d-3ba67d2374a4',
  //   viewAllArrowAlt: 'https://www.figma.com/api/mcp/asset/47720995-3b06-4dc8-9895-bd864b33385c',
  // };

  platformProductItems: DropdownItem[] = [
    {
      label: 'App Integrations',
      subtitle: 'Plug into any app',
      iconUrl: ASSETS.icons.HEADER.APP_INTEGRATION,
      routerLink: ['#'],
    },
    {
      label: 'Prompt-Based Questionnaire',
      subtitle: 'Create from simple prompts',
      iconUrl: ASSETS.icons.HEADER.PROMPT_BASED_QUESTIONNAIRE,
      routerLink: ['#'],
    },
    {
      label: 'Customized Themes',
      subtitle: 'Match your brand',
      iconUrl: ASSETS.icons.HEADER.CUSTOMIZED_THEMES,
      routerLink: ['#'],
    },
    {
      label: 'Automatic Periodic Feedback',
      subtitle: 'Schedule recurring capture',
      iconUrl: ASSETS.icons.HEADER.AUTOMATIC_PERIODIC_FEEDBACK,
      routerLink: [ '#'],
    },
    {
      label: 'Advanced Analytics',
      subtitle: 'Deeper insights fast',
      iconUrl: ASSETS.icons.HEADER.ADVANCED_ANALYTICS,
      routerLink: ['#'],
    },
    {
      label: 'Sentiment Analysis',
      subtitle: 'Track customer mood',
      iconUrl: ASSETS.icons.HEADER.SENTIMENT_ANALYSIS,
      routerLink: ['#'],
    },
    {
      label: 'User Access & Control',
      subtitle: 'Manage roles and rights.',
      iconUrl: ASSETS.icons.HEADER.USER_ACCESS_AND_CONTROL,
      routerLink: ['#'],
    },
  ];

  platformIndustries: DropdownItem[] = [
    {
      label: 'Banking & Finance',
      routerLink: ['#'],
    },
    {
      label: 'Retail & E-commerce',
      routerLink: ['#'],
    },
    {
      label: 'Healthcare',
      routerLink: ['#'],
    },
    {
      label: 'Hospitality & Travel',
      routerLink: ['#'],
    },
    {
      label: 'Telecom & Utilities',
      routerLink: ['#'],
    },
    {
      label: 'SaaS & Tech',
      routerLink: ['#'],
    },
  ];

  platformUseCases: DropdownItem[] = [
    {
      label: 'Customer Experience & Loyalty',
      routerLink: [
        '#'],
    },
    {
      label: 'Product & Feature Feedback',
      routerLink: ['#'],
    },
    {
      label: 'Market & Consumer Research',
      routerLink: ['#'],
    },
    {
      label: 'Employee Experience & HR Feedback',
      routerLink: ['#'],
    },
    {
      label: 'Customer Support & Service Quality',
      routerLink: ['#'],
    },
    {
      label: 'Event & Experience Feedback',
      routerLink: ['#'],
    },
  ];

  resourcesProductItems: DropdownItem[] = [
    // {
    //   label: 'Documentation',
    //   subtitle: 'Quick solutions and answers',
    //   iconUrl: ASSETS.icons.HEADER.DOCUMENTATION,
    //   routerLink: ['#'],
    // },
    // {
    //   label: 'Tutorials',
    //   subtitle: 'Step-by-step product guidance',
    //   iconUrl: ASSETS.icons.HEADER.TUTORIALS,
    //   routerLink: ['#'],
    // },
    {
      label: 'Features',
      subtitle: 'Explore product capabilities',
      iconUrl: ASSETS.icons.HEADER.FEATURES,
      routerLink:[
        APP_ROUTES.GUEST.PRODUCT,
        APP_ROUTES.GUEST.PLATFORM.ROOT,
        APP_ROUTES.GUEST.PLATFORM.FEATURES
      ],
    },
  ];

  resourcesSupportItems: DropdownItem[] = [
    // {
    //   label: 'Help Center',
    //   subtitle: 'Find quick answers & fixes',
    //   iconUrl: ASSETS.icons.HEADER.HELP_CENTER,
    //   routerLink: [APP_ROUTES.GUEST.SUPPORT.ROOT, APP_ROUTES.GUEST.SUPPORT.HELP_CENTER],
    // },
    {
      label: 'Contact us',
      subtitle: 'Reach out to us',
      iconUrl: ASSETS.icons.HEADER.CONTACT_US,
      routerLink: [APP_ROUTES.GUEST.SUPPORT.ROOT, APP_ROUTES.GUEST.SUPPORT.CONTACT_US],
    },
    {
      label: 'FAQs',
      subtitle: 'Common questions, simplified',
      iconUrl: ASSETS.icons.HEADER.FAQ,
      routerLink: [APP_ROUTES.GUEST.SUPPORT.ROOT, APP_ROUTES.GUEST.SUPPORT.FAQ],
    },
  ];

  resourcesCompanyItems: DropdownItem[] = [
    {
      label: 'About Us',
      subtitle: 'Our vision & story',
      iconUrl: ASSETS.icons.HEADER.ABOUT_US,
      routerLink: [APP_ROUTES.GUEST.COMPANY.ROOT, APP_ROUTES.GUEST.COMPANY.ABOUT],
    },
    // {
    //   label: 'Blog',
    //   subtitle: 'Insights & trends',
    //   iconUrl: ASSETS.icons.HEADER.BLOG,
    //   routerLink: ['#'],
    // },
    // {
    //   label: 'Careers',
    //   subtitle: 'Join our growing team',
    //   iconUrl: ASSETS.icons.HEADER.CAREERS,
    //   routerLink: ['#'],
    // },
    // {
    //   label: 'Become a Partner',
    //   subtitle: 'Join Our Partner Network',
    //   iconUrl: ASSETS.icons.HEADER.PARTNERS,
    //   routerLink: ['#'],
    // },
  ];

  platformMobileSections: { title: string; items: DropdownItem[] }[] = [
    {
      title: 'Product',
      items: this.platformProductItems.map((item) => ({
        ...item,
        // iconUrl: this.dropdownAssets.platformItemIcon,
      })),
    },
    {
      title: 'Industries',
      items: this.platformIndustries,
    },
    {
      title: 'Use Cases',
      items: this.platformUseCases,
    },
  ];

  resourcesMobileSections: { title: string; items: DropdownItem[] }[] = [
    {
      title: 'Product',
      items: this.resourcesProductItems,
    },
    {
      title: 'Support',
      items: this.resourcesSupportItems,
    },
    {
      title: 'Company',
      items: this.resourcesCompanyItems,
    },
  ];
}
